module.exports = __webpack_public_path__ + "static/media/Avenir-Medium.78b3d71c.woff2";